// extracted by mini-css-extract-plugin
export var banner = "_fm-0";
export var closeButton = "_fm-2";
export var greenCheckmark = "_fm-3";
export var hereLink = "_fm-4";
export var titleIcon = "_fm-1";